// extracted by mini-css-extract-plugin
export default {"who-we-are":"WhoWeAre_who-we-are__c4Bsn"};